export default __webpack_public_path__ + "static/media/JAMOSO-Exercise-Table.b38ffe35.png";